import React, { useState } from "react";
import "./page.css";
import { IoIosArrowDown } from "react-icons/io";
import RewardsIcon from "../assets/rewards-icon.png"
import ArrowLeft from "../assets/left-icon.png"
import { Link } from 'react-router-dom'

export default function Help() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const accordionData = [
    {
      title: "How to withdraw the amount from wallet!",
      content:
        "After completing every set of orders, you may submit a withdrawal. Please bind your bank information on the platform before you submit for withdrawal. Click the button after entering the amount you want to withdraw and enter your withdrawal password to withdraw. The specific arrival time is subject to the bank's arrival time. Withdrawal charges are subject to the amount and can only be made after have completed the number of reservations assigned by the platform. Accounts are not allowed to keep a remaining balance of more than 1 lakh after applying for Withdrawal. The maximum withdrawal is 80 lakh if you withdraw more than 10 lakh, you will need to pay a fee of 50% for the first time for verification and security purposes, the fees can be withdrawn too after 1 hour of verification.",
    },
    {
      title: "How to deposit!",
      content: "After completing every set of orders, you may submit a withdrawal. Please bind your bank information on the platform before you submit for withdrawal. Click the button after entering the amount you want to withdraw and enter your withdrawal password to withdraw. The specific arrival time is subject to the bank's arrival time. Withdrawal charges are subject to the amount and can only be made after have completed the number of reservations assigned by the platform. Accounts are not allowed to keep a remaining balance of more than 1 lakh after applying for Withdrawal. The maximum withdrawal is 80 lakh if you withdraw more than 10 lakh, you will need to pay a fee of 50% for the first time for verification and security purposes, the fees can be withdrawn too after 1 hour of verification.",
    },
    {
      title: "What is the pending and On hold!",
      content: "After completing every set of orders, you may submit a withdrawal. Please bind your bank information on the platform before you submit for withdrawal. Click the button after entering the amount you want to withdraw and enter your withdrawal password to withdraw. The specific arrival time is subject to the bank's arrival time. Withdrawal charges are subject to the amount and can only be made after have completed the number of reservations assigned by the platform. Accounts are not allowed to keep a remaining balance of more than 1 lakh after applying for Withdrawal. The maximum withdrawal is 80 lakh if you withdraw more than 10 lakh, you will need to pay a fee of 50% for the first time for verification and security purposes, the fees can be withdrawn too after 1 hour of verification.",
    },
    {
      title: "What is a gold suit package!",
      content: "After completing every set of orders, you may submit a withdrawal. Please bind your bank information on the platform before you submit for withdrawal. Click the button after entering the amount you want to withdraw and enter your withdrawal password to withdraw. The specific arrival time is subject to the bank's arrival time. Withdrawal charges are subject to the amount and can only be made after have completed the number of reservations assigned by the platform. Accounts are not allowed to keep a remaining balance of more than 1 lakh after applying for Withdrawal. The maximum withdrawal is 80 lakh if you withdraw more than 10 lakh, you will need to pay a fee of 50% for the first time for verification and security purposes, the fees can be withdrawn too after 1 hour of verification.",
    },
    {
      title: "Platform working time!",
      content: "After completing every set of orders, you may submit a withdrawal. Please bind your bank information on the platform before you submit for withdrawal. Click the button after entering the amount you want to withdraw and enter your withdrawal password to withdraw. The specific arrival time is subject to the bank's arrival time. Withdrawal charges are subject to the amount and can only be made after have completed the number of reservations assigned by the platform. Accounts are not allowed to keep a remaining balance of more than 1 lakh after applying for Withdrawal. The maximum withdrawal is 80 lakh if you withdraw more than 10 lakh, you will need to pay a fee of 50% for the first time for verification and security purposes, the fees can be withdrawn too after 1 hour of verification.",
    },

    {
      title: "Procedure for withdraw the higher amount to be followed!",
      content: "Members can withdraw up to 80LK on one shot please consult with the respective senior members and proceed according for the smooth withdrawal process.",
    },
    {
      title: "Tax and TDS details!",
      content: "Every transaction done from the merchant side to the members are TAX paid and you can clain the TDS from the finance team while filing the ITR, how ever the bigger earning TAX amount will not be paid from the merchant side and that have to be bear by the receiving party and after submitting the TAX claim form the same can be refunded to the receiver account.",
    },
  ];

  return (
    <>
      <div className='rewards_section'>
        <div className='container'>
          <div className='rewards_heading'>
            <img src={RewardsIcon} />
            <p>Book Now & Earn Rewards</p>
          </div>
        </div>
      </div>
      
      <div className='inner_title_section'>
          <div className='container'>
            <div className='inner_title_flex'>
              <Link to='/booking'> <img src={ArrowLeft} /></Link>
              <h3>Help</h3>
            </div>
          </div>
        </div>

      <div className="container">
        <div className="accordion-container">
          {accordionData.map((item, index) => (
            <div key={index} className="accordion-item">
              <button
                className={`accordion-header ${openIndex === index ? "active" : ""}`}
                onClick={() => toggleAccordion(index)}
              >
                {item.title}
                <span className={`arrow ${openIndex === index ? "rotate" : ""}`}><IoIosArrowDown /> </span>

              </button>
              <div className={`accordion-content ${openIndex === index ? "open" : ""}`}>
                {item.content}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
